import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Logo from "../img/graphics/NAS Logo Color smaller.png";

const CONTACT_ENDPOINT = "/contact.php";
const CONTACT_EMAIL = "trish_hambridge@yahoo.com";

export default function Contact() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    peerBefriending: searchParams.get("pb") === "1",
    website: "", // honeypot — real visitors never see or fill this
  });

  const update = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) throw new Error(data.error || "Send failed");
      setStatus("sent");
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="page page--narrow">
      <h1 className="page-title">Contact</h1>

      <div className="contact-card">
        <div className="contact-card__head">
          <img src={Logo} alt="" className="contact-card__logo" />
          <div>
            <h2>Contact National Aphasia Synergy</h2>
            <p>A peer-led community. We’ll get back to you soon.</p>
          </div>
        </div>

        {status === "sent" ? (
          <div className="contact-success" role="status">
            <h3>Thank you!</h3>
            <p>Your message was sent. We’ll get back to you soon.</p>
          </div>
        ) : (
          <form className="contact-form" onSubmit={submit}>
            <label>
              Name
              <input name="name" value={form.name} onChange={update} required autoComplete="name" />
            </label>
            <label>
              Email
              <input type="email" name="email" value={form.email} onChange={update} required autoComplete="email" />
            </label>
            <label>
              Phone (optional)
              <input type="tel" name="phone" value={form.phone} onChange={update} autoComplete="tel" />
            </label>
            <label>
              Message
              <textarea name="message" rows="6" value={form.message} onChange={update} placeholder="How can we help?" />
            </label>

            <label className="hp" aria-hidden="true">
              Website
              <input name="website" value={form.website} onChange={update} tabIndex="-1" autoComplete="off" />
            </label>

            <label className="contact-optin">
              <input type="checkbox" name="peerBefriending" checked={form.peerBefriending} onChange={update} />
              <span>Yes, please contact me about the Peer Befriending program!</span>
            </label>

            <button type="submit" className="contact-submit" disabled={status === "sending"}>
              {status === "sending" ? "Sending…" : "Send message"}
            </button>

            {status === "error" && (
              <p className="contact-error" role="alert">
                Sorry, your message didn’t send. Please email us at{" "}
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
              </p>
            )}
          </form>
        )}
      </div>
    </div>
  );
}
